import React, {useState, useEffect} from 'react';
import { useRef } from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Button, Badge } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import { WQSAMPLES, SAMPLINGPOINTS, COMPANY, USERSFILTER, WQREPORTDATA, APACHE_URL } from 'helpers/url_helper';
import { Config, TOAST_OPTIONS, formatDate, encryptId } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {PaginationListStandalone, PaginationProvider,} from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';

import PropTypes from 'prop-types';

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import { useHistory } from 'react-router-dom';

    const WaterSampling = () => {

        const { ExportCSVButton } = CSVExport;
        const history = useHistory()

        toastr.options = TOAST_OPTIONS;

        const [modal, setmodal] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [dataList, setDataList] = useState([]);
        const [paramsList, setParamsList] = useState([]);
        const [sPointsList, setSPointsList] = useState([]);
        const [isloading, setIsloading] = useState(false);
        const [filterDate, setFilterDate] = useState('')
        const [assigns, setAssigns] = useState([])

        const [sDate, setSDate]         = useState([])
        const [eDate, setEDate]         = useState([])
        const [sPoint, setSPoint]       = useState('')
        const [sStaff, setSStaff]       = useState('')


        const fetchData = () => {
          const udata = {
            id    :"",
            name  :"",
            title :"",
            dept  :"4",
            category:"",
            area:"WQMIS"
        }
        axios.post(USERSFILTER, JSON.stringify(udata), Config).then((r)=>{ 
            setAssigns(r.data)
        }).catch((e)=>{  
            console.log(e); 
        });
          const data = {
            id: '',
            sDate: '',
            eDate: '',
            sPoint: '',
            sStaff: ''      
          }
          setIsloading(true)
          axios.post(WQSAMPLES, JSON.stringify(data), Config).then((r)=>{ setDataList(r.data);  setIsloading(false); }).catch((e)=>{  console.log(e); setIsloading(false); });
            axios.get(SAMPLINGPOINTS, Config).then((r)=>{ setSPointsList(r.data);  }).catch((e)=>{  console.log(e); });
            
        }

        useEffect(() => {
          fetchData();
        },[]);

        const handleFilterData = () =>{
          const data = {
            id: '',
            sDate: formatDate(sDate[0]),
            eDate: formatDate(eDate[0]),
            sPoint: sPoint,
            sStaff: sStaff      
          }
          setIsloading(true)
          axios.post(WQSAMPLES, JSON.stringify(data), Config).then((r)=>{ setDataList(r.data);  setIsloading(false); }).catch((e)=>{  console.log(e); setIsloading(false); });
        }
        const handleExport = () =>{
          const data = {
            id : '',
            sDate: formatDate(sDate[0]),
            eDate: formatDate(eDate[0]),
            sPoint: sPoint,
            sStaff: sStaff      
          }
          if(sPoint == ""){
            toastr.error('Select sampling point')
          }else{
          setIsloading(true)
          axios.post(WQREPORTDATA, JSON.stringify(data), Config).then((r)=>{ 
            const urlx = APACHE_URL + "attach/wqqoutput.xlsx"
            axios({
              url: urlx,
              method: 'GET',
              responseType: 'blob',
            })
            .then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', `Water-Data-Quality-Report.xlsx`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
              console.error('Error downloading the file:', error);
            });
            setIsloading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsloading(false)
          });
        }
        }
        const pageOptions = {
          sizePerPage: 10000,
          totalSize: dataList.length,
          custom: true,
        };
        var node = useRef();

        const { SearchBar } = Search;
        const columns = [
        
        {
          dataField: 'date',
          text: 'Date',
          sort: true,
          formatter: dateFormatter
        }
        ,
        {
          dataField: 'sample',
          text: 'Sample',
          sort: true
        },
        {
          dataField: 'point',
          text: 'Sampling Point',
          sort: true
        },
        {
            dataField: 'pointType',
            text: 'Type',
            sort: true
          },
        {
            dataField: 'param',
            text: 'Parameters',
            sort: true,
            align:'center',
            headerStyle: { textAlign: 'center' }, 
            formatter:paramsFormatter
        },
        {
            dataField: 'status',
            text: 'status',
            sort: true,
            align:'center',
            headerStyle: { textAlign: 'center' }, 
            formatter: statusFormatter
        },
        {
            dataField: 'postedBy',
            text: 'Posted By',
            sort: true
        },
        {
            dataField: "action",
            isDummyField: true,
            text: "Action",
            formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'date',
          order: 'desc'
        }];
        function actionFormatter(cellContent, row){
          return(
            <>
              <Button
                type="button"
                color="info"
                className="btn-sm btn-rounded"
                onClick={()=>{ history.push(`/Water-Quality-Details/${encryptId(row.id)}`)}}>
                Details
              </Button>
            </>
          )
        }
        function statusFormatter(cellContent, row) {
          if (row.status == "Closed") {
            return (
              <div>
                  <Badge className="me-2 bg-success">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else if(row.status == "Pending Approval"){
            return (
              <div>
                  <Badge className="me-2 bg-warning">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-danger">
                  { cellContent }
                  </Badge>
              </div>
            );
          }
        }
        function paramsFormatter(cellContent, row){
            return(<span> {row.sampleData.length}</span>)
        }
        function dateFormatter(cellContent, row){
            return(<span> {formatDate(cellContent)}</span>)
        }

        return (
            <>
            <LoadingOverlay
              active={isloading}
              spinner={<BounceLoader />}
              text='Please wait...'
              >
                <div className="page-content">
                    <MetaTags>
                    <title>Collected Samples | {COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>

                        <Row>
                        <Col lg={12}>
                          <Card>
                          <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                            <CardBody>
                              <Row className="justify-content-center mb-2">
                                  <Col md={2}>
                                      <div className="mb-3">
                                          <label>From</label>
                                          <Flatpickr
                                            className="form-control form-control-sm"
                                            options={{
                                                dateFormat: "Y-m-d",
                                                enableTime: false
                                            }}
                                            value={sDate}
                                            onChange={(dates)=>setSDate(dates)}
                                            />
                                      </div>
                                  </Col>
                                  <Col md={2}>
                                      <div className="mb-3">
                                          <label>Till </label>
                                          <Flatpickr
                                              className="form-control form-control-sm"
                                              options={{
                                                  dateFormat: "Y-m-d",
                                                  enableTime: false
                                              }}
                                              value={eDate}
                                              onChange={(dates)=>setEDate(dates)}
                                              />
                                      </div>
                                  </Col>
                                  <Col md={2}>
                                      <div className="mb-3">
                                          <label>Sampling Point</label>
                                          <select className="form-select form-select-sm" value={sPoint} onChange={(e)=>setSPoint(e.target.value)}>
                                          <option value=""></option>
                                          { sPointsList && (sPointsList.length > 0) && (
                                              (sPointsList || []).map((p,k)=>(
                                                  <option key={k} value={p.id}>{p.name}</option>
                                              ))
                                          )}
                                          </select>
                                      </div>
                                  </Col>
                                  <Col md={2}>
                                      <div className="mb-3">
                                          <label>Staff</label>
                                          <select className="form-select form-select-sm" value={sStaff} onChange={(e)=>setSStaff(e.target.value)}>
                                              <option value=""></option>
                                              {assigns.map((c,k)=>(
                                                  <option value={c.name} key={k}>{c.name}</option>
                                              ))}
                                          </select>
                                      </div>
                                  </Col>
                              </Row>
                              <Row  className="justify-content-center mb-2">
                                <Col lg={2} className='mb-2'> 
                                  <div className="d-grid gap-2">
                                      <Button
                                        color='warning'
                                        className="btn btn-sm"
                                        onClick={handleFilterData}
                                      >
                                        <i className="mdi mdi-magnify me-1" />
                                        Fetch Sampling Data
                                      </Button>
                                    </div>
                                  </Col>
                                 {/*
                                  <Col lg={2} className='mb-2'> 
                                  <div className="d-grid gap-2">
                                      <Button
                                        color='success'
                                        className="btn btn-sm"
                                        onClick={handleExport}
                                      >
                                        <i className="mdi mdi-export me-1" />
                                        Export to Excel
                                      </Button>
                                    </div>
                                  </Col>
                                  */}
                      
                                  <Col lg={2} className='mb-2'> 
                                  <div className="d-grid gap-2">
                                      <Button
                                        color='primary'
                                        className="btn btn-sm"
                                        onClick={()=>{ history.push('/Add-Quality-Data')}}
                                      >
                                        <i className="mdi mdi-notification-clear-all me-1" />
                                        Submit data
                                      </Button>
                                    </div>
                                  </Col>
                                  
                                </Row>
                               
                              
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>  
                      <Row>             
                        <Col lg="12">
                        <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase">{dataList.length} Water Quality Samples</h5>
                            <CardBody>

                            {dataList && (dataList.length > 0) && (
                                <>
                                <PaginationProvider
                                pagination={paginationFactory(pageOptions)}
                                keyField="id"
                                columns={columns}
                                data={dataList}
                              >
                                {({ paginationProps, paginationTableProps }) => (
                                <ToolkitProvider
                                      keyField="id"
                                      data={ dataList }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                            
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={ dataList } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  //onTableChange={handleTableChange}
                                                    {...paginationTableProps}
                                                  ref={node}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            <Row className="align-items-md-center mt-30">
                                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                                <PaginationListStandalone
                                                  {...paginationProps}
                                                />
                                              </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>
                                  )}
                                </PaginationProvider>

                                </>
                            )}
                            {dataList && (dataList.length < 1) && (
                                <div className="text-center">
                                    <div className="mb-4">
                                    <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                    </div>
                                    <div>
                                    <h5>No Data Found</h5>
                                    <p className="text-muted">
                                            
                                    </p>
                                    </div>
                                </div>

                            )}
                            </CardBody>
                        </Card>
                        </Col>
                    </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }
    WaterSampling.propTypes = {
        csvProps: PropTypes.any,
        baseProps: PropTypes.any
      };
export default WaterSampling;